<div class="crm-read-only-container" *ngIf="readOnly">
  <div class="crm-field-label">{{ label | translate }}</div>
  <div class="crm-field-value">
    <ng-container *ngTemplateOutlet="crmFieldValue"></ng-container>
  </div>
</div>
<div *ngIf="isInlineEdit$ | async">
  <crm-model-driven-popover
    [label]="label"
    [displayValue]="readonlyPhoneNumber()"
    [control]="control"
    (save)="saveField()"
  >
    <ng-container *ngTemplateOutlet="formField"></ng-container>
  </crm-model-driven-popover>
</div>
<ng-container *ngIf="!readOnly && (isInlineEdit$ | async) === false">
  <ng-container *ngTemplateOutlet="formField"></ng-container>
</ng-container>
<ng-template #formField>
  <div class="crm-phone-form" [formGroup]="phone">
    <glxy-label *ngIf="label">{{ label | translate }}</glxy-label>
    <glxy-form-row>
      <glxy-form-field
        class="col-xs-3 col-sm-2 crm-phone-country"
        [attr.data-testid]="'phone-country-field-with-id-' + fieldId"
      >
        <mat-select formControlName="country" [placeholder]="'MODEL_DRIVEN_FORM.PHONE.COUNTRY_LABEL' | translate">
          <mat-select-trigger>
            <p
              *ngIf="selectedCountry() as selectedCountry; else invalidCountryTrigger"
              [attr.aria-label]="selectedCountry.countryName"
            >
              {{ selectedCountry.flag }}
            </p>
          </mat-select-trigger>
          <!-- if this ever happens something is wrong -->
          <ng-template #invalidCountryTrigger>Invalid</ng-template>
          <mat-option>
            <ngx-mat-select-search
              [placeholderLabel]="'MODEL_DRIVEN_FORM.PHONE.SEARCH_COUNTRY_LABEL' | translate"
              [noEntriesFoundLabel]="'MODEL_DRIVEN_FORM.PHONE.SEARCH_COUNTRY_NO_RESULTS' | translate"
              [formControl]="searchCountryControl"
            ></ngx-mat-select-search>
          </mat-option>
          <mat-option
            class="crm-phone-country-option"
            *ngFor="let option of filteredCountryOptions$ | async"
            [value]="option.countryCode"
          >
            <span class="crm-phone-country-option-calling-code">{{ option.callingCode }}</span>
            <span class="crm-phone-country-option-display">({{ option.flag }} {{ option.countryName }})</span>
          </mat-option>
        </mat-select>

        <!-- only set error so that extension field gets invalid styling -->
        <glxy-error *ngIf="phone.hasError('invalidPhoneNumber')"></glxy-error>
      </glxy-form-field>
      <glxy-form-field
        [crmFieldWarning]="validation"
        [warningControl]="control"
        class="col-xs-9 col-sm-7 crm-phone"
        [attr.data-testid]="'phone-field-with-id-' + fieldId"
      >
        <span class="crm-phone-code-prefix" matPrefix>{{ selectedCountryCallingCode() }}</span>
        <input matInput formControlName="phoneNumber" [attr.autocomplete]="disableAutoComplete" digitOnly type="tel" />
        <!-- only set error so that extension field gets invalid styling -->
        <glxy-error *ngIf="phone.hasError('invalidPhoneNumber')"></glxy-error>
      </glxy-form-field>
      <glxy-form-field
        class="col-xs-12 col-sm-3 crm-phone-extension"
        [attr.data-testid]="'phone-extension-field-with-id-' + fieldId"
        [attr.autocomplete]="disableAutoComplete"
        [bottomSpacing]="'none'"
      >
        <input
          matInput
          formControlName="extension"
          [placeholder]="'MODEL_DRIVEN_FORM.PHONE.EXTENSION_LABEL' | translate"
          [attr.autocomplete]="disableAutoComplete"
          digitOnly
          type="tel"
        />
        <!-- only set error so that extension field gets invalid styling -->
        <glxy-error *ngIf="phone.hasError('invalidPhoneNumber')"></glxy-error>
      </glxy-form-field>
    </glxy-form-row>
    <glxy-error class="crm-phone-form-error" *ngIf="phone.hasError('invalidPhoneNumber')">
      {{ 'MODEL_DRIVEN_FORM.PHONE.INVALID_PHONE_ERROR' | translate }}
    </glxy-error>
    <crm-model-driven-form-error
      [objectType]="objectType"
      [fieldId]="fieldId"
      [label]="label"
      [control]="control"
      [validation]="validation"
    ></crm-model-driven-form-error>
  </div>
</ng-template>
<ng-template #crmFieldValue>
  <ng-container *ngIf="control.invalid; else phoneLink">{{ initialValue }}</ng-container>
  <ng-template #phoneLink>
    <a [href]="RFC3966PhoneNumber()" *ngIf="readonlyPhoneNumber() as readonlyPhoneNumber">
      <span>{{ readonlyPhoneNumber }}</span>
    </a>
  </ng-template>
</ng-template>
